import React from "react";
import { Link } from "react-router";

import { routeCodes } from "../../config/routes";
import ABCyaLogo from "../../../assets/svg/abcyalogo.svg";
import Nav from "./Nav";
import SearchField from "./searchField";

export default function Header() {
  return (
    <div id="header" className="header">
      <div className="container header-container">
        <div className="header-nav-left">
          <div className="header-logo">
            <Link to={routeCodes.HOME}>
              <ABCyaLogo className="header-logo-img" />
            </Link>
          </div>
          <SearchField />
        </div>
        <div className="header-nav-right">
          <Nav />
        </div>
      </div>
    </div>
  );
}
